import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EditItemForm  from '../../../booking/components/regular_shuttle/EditItemForm';
import { bindActionCreators } from 'redux';
import { cancel, updateServiceItem, removeServiceItem } from '../../../../data/booking/actions/booking';
import { normalizeItem } from '../../../../data/booking/normalizers/regular_shuttle';
import { getEditValues } from '../../../../data/booking/selectors/regular_shuttle_form';
import { getEditingService, getEditingItem } from '../../../../data/booking/selectors/booking';
import { suggestRegularShuttleJourney } from '../../../../data/shared/api/api';
import isEmpty from "lodash/isEmpty";

class EditItemFormContainer extends Component {
    static propTypes = {
        initialValues: PropTypes.object,
        service: PropTypes.object,
        item: PropTypes.object,
        updateServiceItem: PropTypes.func,
        cancel: PropTypes.func,
        removeServiceItem: PropTypes.func
    };

    state = {
        isLoading: true,
        journeys: []
    };

    componentWillMount() {
        // Dans initialValues on a:
        // {
        //     date,
        //     people,
        //     journey {
        //         departure: { stop },
        //         arrival: { stop },
        //         lineId,
        //         time
        //     }
        // }

        // Mais on veut récupérer les journeys dans arrival
        // Pour ça il faut utiliser un call api dans lequel
        // on passe le departure et la ligne
        // Dans le résultat il faut retrouver la journey qui
        // correspond et insérer les différentes heures possibles
        // dans arrival

        const { item } = this.props;

        suggestRegularShuttleJourney(null, {
            stop:  item.from.id,
            step:  item.from.step.id,
            lines: [item.lineId]
        })
            .then(response => response.json())
            .then(data => {
                const arrival = data.find(j => j.id === item.to.id);

                this.setState({
                    isLoading: false,
                    journeys: !isEmpty(arrival) && arrival.journeys ? arrival.journeys : []
                })
            });
    }

    handleSubmit(values) {
        this.props.updateServiceItem(this.props.item.id, normalizeItem(values))
            .then(() => this.props.cancel());
    }

    handleClickBack(e) {
        e.preventDefault();
        e.stopPropagation();

        this.props.cancel();
    }

    handleRemove() {
        const { service, item } = this.props;

        this.props.removeServiceItem(service.id, item.id);
    }

    render() {
        const { service, initialValues } = this.props;
        const { isLoading, journeys } = this.state;

        if (isLoading) {
            return <></>;
        }

        return (
            <EditItemForm
                route={service.route}
                initialValues={{
                    ...initialValues,
                    journey: {
                        ...initialValues.journey,
                        arrival: {
                            ...initialValues.journey.arrival,
                            journeys
                        }
                    }
                }}
                handleSubmit={::this.handleSubmit}
                onClickBack={::this.handleClickBack}
                onRemove={::this.handleRemove}
            />
        );
    }
}

export default connect(
    state => ({
        service: getEditingService(state.booking),
        item: getEditingItem(state.booking),
        initialValues: getEditValues(state.booking)
    }),
    dispatch => bindActionCreators({ cancel, updateServiceItem, removeServiceItem }, dispatch)
)(EditItemFormContainer);
